import { render, staticRenderFns } from "./DashboardSales.vue?vue&type=template&id=742b7e54"
import script from "./DashboardSales.vue?vue&type=script&lang=js"
export * from "./DashboardSales.vue?vue&type=script&lang=js"
import style0 from "./DashboardSales.vue?vue&type=style&index=0&id=742b7e54&prod&lang=css"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports